import React, { useState, useEffect, useRef } from "react";
import { ParallaxBanner } from "react-scroll-parallax";
import { Card, Container } from "react-bootstrap";
import Us from "./Us";
import Courses from "./Courses";
import Services from "./Services";

import home from "./../../assets/pictures/home.jpg";

const Home = () => {
	const layer = { image: home, amount: 0.3 };
	const containerRef = useRef(null);
	const [width, setWidth] = useState(1);

	useEffect(() => {
		const resizeListener = () => {
			if (containerRef.current) setWidth(containerRef.current.clientWidth);
		};
		window.addEventListener("resize", resizeListener);
		return () => {
			window.removeEventListener("resize", resizeListener);
		};
	}, []);

	const getCard = (title, message, button, classname) => {
		return (
			<Card className={`text-white text-left ${classname}`} style={{ width: "326px", height: "261px" }}>
				<Card.Body className="d-flex flex-column">
					<Card.Title className="banner-card-title">{title}</Card.Title>
					<div className="flex-grow-1 d-flex">
						<Card.Text className="mx-auto align-self-center">{message}</Card.Text>
					</div>
					<div className="d-flex justify-content-end">
						<Card.Link className="text-info font-weight-bold" href={button.href}>
							{button.text}
						</Card.Link>
					</div>
				</Card.Body>
			</Card>
		);
	};

	return (
		<>
			<div
				ref={(element) => {
					containerRef.current = element;
					if (element) setWidth(element.clientWidth);
				}}>
				<ParallaxBanner
					expanded={true}
					layers={[layer]}
					style={{
						height: "540px",
					}}>
					<div className="absolute-centered" style={{ width: `${width}px` }}>
						<Container className="p-0 p-md-auto">
							<div className="d-flex flex-column flex-md-row justify-content-start">
								<div className="col-12 col-md-auto pb-1 pb-md-0">
									{getCard(
										"Capacitación para Litigantes",
										"Nuestros talleres  están diseñados para que cada participante amplié sus conocimientos y ponga en práctica técnicas de litigación oral.",
										{ href: "#talleres", text: "Ver Talleres" },
										"bg-blue",
									)}
								</div>
								<div className="col-12 col-md-auto pt-md-5">
									{getCard(
										"Representación Jurídica",
										"Contamos con un amplio equipo de abogados altamente capacitados en materia penal, familiar, civil, fiscal, administrativo y mercantil.",
										{ href: "#contacto", text: "Solicitar una asesoría" },
										"bg-gray",
									)}
								</div>
							</div>
						</Container>
					</div>
				</ParallaxBanner>
			</div>
			<h1 className="bg-blue mt-5 p-4 text-left" id="nosotros">
				Nosotros
			</h1>
			<div className="bg-white p-4">
				<Us />
			</div>
			<h1 className="bg-blue p-4 text-left" id="servicios">
				Nuestros Servicios
			</h1>
			<div className="p-4">
				<Services />
			</div>
			<h1 className="bg-blue p-4 text-left" id="talleres">
				Capacitación Jurídica
			</h1>
			<div className="bg-white p-4">
				<Courses />
			</div>
		</>
	);
};

export default Home;
